import { useAxiosRequest } from "api/axiosRequest"
import { VesselInfo } from "./useFetchVesselInfo"
import { BASE_URL } from "api/url_helper"
import { useState } from "react"

export interface AddVesselStruct {
  listId: string
  vesselImo: string
  vesselName: string
  vesselDwt: string
  vesselSegment: string
  expirationDate: Date
}

export interface BulkAddVesselStruct {
  listId: string
  vesselImo: string[]
  vesselName: string[]
  vesselDwt: string[]
  vesselSegment: string[]
  expirationDate: Date
}

export function useAddVesselToList() {
  const [isAddVesselLoading, setIsAddVesselLoading] = useState<boolean>(false)
  const [isBulkAddVesselLoading, setIsBulkAddVesselLoading] =
    useState<boolean>(false)
  const request = useAxiosRequest()

  const AddVesselToList = async (vessel: AddVesselStruct, source?: string) => {
    setIsAddVesselLoading(true)
    try {
      await request<any, VesselInfo>({
        url: `${BASE_URL}/vesseltracking/vessel/single`,
        method: "POST",
        data: vessel,
        params: source ? { source } : undefined,
      })
    } finally {
      setIsAddVesselLoading(false)
    }
  }

  const BulkAddVesselToList = async (vessels: BulkAddVesselStruct) => {
    setIsBulkAddVesselLoading(true)
    try {
      await request<any, void>({
        url: `${BASE_URL}/vesseltracking/vessels`,
        method: "POST",
        data: vessels,
      })
    } finally {
      setIsBulkAddVesselLoading(false)
    }
  }

  return {
    AddVesselToList,
    isAddVesselLoading,
    BulkAddVesselToList,
    isBulkAddVesselLoading,
  }
}
